import request from '@/utils/request'

/**
 * 查询角色元件
 * @param {Object} params 
 * @returns 
 */
export function listRoleComponent(params) {
  return request({
    url: '/component/role_component/list',
    method: 'GET',
    params,
  })
}

/**
 * 添加角色元件
 * @param {Object} data 
 * @returns 
 */
export function addRoleComponent(data) {
  return request({
    url: '/component/role_component/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改角色元件
 * @param {Object} data 
 * @returns 
 */
export function updateRoleComponent(data) {
  return request({
    url: '/component/role_component/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeRoleComponent(data) {
  return request({
    url: '/component/role_component/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加角色元件
 * @param {Object} data 
 * @returns 
 */
export function getRoleComponentById(data) {
  return request({
    url: '/component/role_component/getById',
    method: 'get',
    data,
  })
}

